<!--  -->
<template>
    <div class="layout" :style="layoutBgColor()">
      <template v-if="globalConfig">
        <Header />
        <headerBanner />
          <div class="layout__main">
            <Menu :globalConfig='globalConfig' :routeList="routes" />
            <slot/>
          </div>
        <Footer />
        <Elements :list='globalConfig.elements' />
        <!-- <CheckNetwork /> -->
      </template>
    </div>
</template>

<script>
import Header from '@/components/Header'
import headerBanner from '@/components/headerBanner'
import Menu from '@/components/Menu'
import Footer from '@/views/home/footer'
import { mapState } from 'vuex'
import Elements from './Elements'

export default {
  data () {
    return {
    };
  },

  components: {
    Header,
    headerBanner,
    Menu,
    Footer,
    Elements,
  },
  computed: {
     ...mapState({
        globalConfig: state => state.router.globalConfig,
        routes: state => state.router.routeList,
    }),
  },
  methods:{
     layoutBgColor() {
      const defaultStyle = {
        'background-color': '#FCF1D5',
      };
      if(this.globalConfig && this.globalConfig.bg){
        return {
          backgroundColor: this.globalConfig.bg.value
        }
      } 
      return defaultStyle;
      
    }
  },
  mounted(){
    
  }
}

</script>
<style lang='less' scoped>
.layout {
  position: relative;
  display: flex;
  flex-direction: column;
  // min-height:100%;
  min-height:100%;
  overflow: hidden;
  padding-bottom:330px;
  z-index: 2;
  &__main {
    min-height: 1%;
    flex: 1;
    position: relative;
    padding-top:98px;
    z-index: 1;
    // background-color: #FCF1D5;
  }
}
</style>